import {
    useBodyScrollLock,
    useScrollFocusedIntoView,
    useVisualViewportProperties,
} from "@xapp/chat-widget-core";
import React, { FC, PropsWithChildren } from "react";
import styles from "./ModalDialog.module.scss";

export interface ModalDialogProps {
    /**
     * Removes the backdrop overlay
     *
     * Setting this to true will then disable the click backdrop to close functionality
     */
    readonly disableBackdrop?: boolean;
    /**
     * Callback when the user requests to close the modal by clicking the backdrop.
     */
    onClose(): void;
}

export const ModalDialog: FC<PropsWithChildren<ModalDialogProps>> = (props) => {
    // This used to add a class that set `body { overflow: hidden }`, which iOS Safari
    // ignores — the host page scrolled on underneath the open modal.
    useBodyScrollLock();

    // Keeps the step's action row clear of the soft keyboard — see the calc() on
    // .xapp_search_modal's mobile padding. Reference counted, so the chat widget's own
    // subscription survives this modal closing while its keyboard is still up.
    useVisualViewportProperties();

    // Browsers do this themselves, but not reliably inside a position: fixed overlay -
    // tapping the last field on a step could leave it behind the keyboard.
    useScrollFocusedIntoView();

    return (
        <div className={styles.xapp_search_modal}>
            {!props.disableBackdrop && (
                <div className={styles["xapp_search_modal__backdrop"]} onClick={props.onClose} />
            )}
            <div className={styles["xapp_search_modal__body"]}>{props.children}</div>
        </div>
    );
};
